/* ADMA Studio launch layer: mobile sticky purchase, >1000 kg freight guard and mobile filter drawer. Runs after a2.js. */
(()=>{'use strict';
const $=(s,r=document)=>r.querySelector(s), $$=(s,r=document)=>[...r.querySelectorAll(s)];
const money=v=>new Intl.NumberFormat('es-ES',{style:'currency',currency:'EUR'}).format(Number(v));
const limit=window.AdmaFreight?.limit||1000000;
const note=ref=>window.AdmaFreight?.note?.(ref)||'<strong>Motor de más de 1.000 kg.</strong> El transporte se presupuesta aparte.';
const waFreight=ref=>'https://wa.me/34695537203?text='+encodeURIComponent('Hola, quiero precio con transporte para '+ref);

// Product page: the variant select stays the single source of truth; this layer only mirrors it.
$$('[data-pdp]').forEach(root=>{
 const select=$('[data-pdp-variant]',root),main=$('[data-add-cart]',root),bar=$('[data-sticky-buy]',root),row=$('.a2-buy-row',root),freight=$('[data-pdp-freight]',root);
 if(!select||!main)return;
 const vs=JSON.parse($('[data-pdp-variants]',root)?.textContent||'[]');
 const stickyAdd=$('[data-sticky-add]',root),stickyFreight=$('[data-sticky-freight]',root);
 const heavy=v=>Number(v?.weight)>limit;
 function sync(){
  const v=vs.find(v=>String(v.id)===select.value);if(!v)return;
  const ref=`${root.dataset.handle} · ${v.sku} · Montaje ${v.title}`;
  if(heavy(v)){main.disabled=true;if(freight){freight.innerHTML=note(`${v.sku} · Montaje ${v.title}`);freight.hidden=false;}}
  else if(freight){freight.hidden=true;freight.textContent='';}
  const vat=money(v.price/100);
  $$('[data-pdp-price-vat],[data-sticky-price-vat]',root).forEach(n=>n.textContent=vat);
  $$('[data-mount-pick]',root).forEach(b=>{const on=b.dataset.mountPick===select.value;b.classList.toggle('is-on',on);b.setAttribute('aria-pressed',String(on));});
  $$('[data-pdp-mount-code]',root).forEach(n=>n.textContent=v.title);
  if(bar){
   $('[data-sticky-price]',bar).textContent=money(v.price/100);
   $('[data-sticky-mount]',bar).textContent='Montaje '+v.title;
   stickyAdd.hidden=heavy(v);stickyFreight.hidden=!heavy(v);stickyFreight.href=waFreight(ref);
   stickyAdd.disabled=main.disabled;
  }
 }
 select.addEventListener('change',sync);
 // Premium PDP: mount pills and cards drive the native select, which stays the source of truth.
 $$('[data-mount-pick]',root).forEach(b=>b.addEventListener('click',()=>{if(select.value===b.dataset.mountPick)return;select.value=b.dataset.mountPick;select.dispatchEvent(new Event('change',{bubbles:true}));}));
 const qty=$('input[name="quantity"]',root);
 $$('[data-qty]',root).forEach(b=>b.addEventListener('click',()=>{if(!qty)return;qty.value=Math.max(1,(parseInt(qty.value,10)||1)+Number(b.dataset.qty));}));
 $$('[data-open-plan]',root).forEach(a=>a.addEventListener('click',()=>{const d=$('#px-plan',root);if(d)d.open=true;}));
 // a2.js re-enables the button after every add; keep the freight guard and the mirror in step.
 new MutationObserver(()=>{const v=vs.find(v=>String(v.id)===select.value);if(heavy(v)&&!main.disabled)main.disabled=true;if(stickyAdd){stickyAdd.disabled=main.disabled;stickyAdd.textContent=main.textContent.includes('Añadiendo')?'Añadiendo…':'Añadir al carrito';}}).observe(main,{attributes:true,attributeFilter:['disabled'],childList:true,characterData:true,subtree:true});
 sync();
 if(bar&&row&&'IntersectionObserver'in window){
  const mobile=window.matchMedia('(max-width:760px)');let rowVisible=true;
  const toggle=()=>{bar.hidden=!mobile.matches||rowVisible;};
  new IntersectionObserver(es=>{rowVisible=es[0].isIntersecting;toggle();}).observe(row);
  mobile.addEventListener?.('change',toggle);
 }
});

// Collection: on mobile the filters live in a drawer behind one button; search stays visible.
$$('[data-filter-bar]').forEach(bar=>{
 const btn=$('[data-filter-toggle]',bar),count=$('[data-filter-count]',bar),root=bar.closest('[data-catalog]');if(!btn)return;
 const update=()=>{const n=$$('[data-filter]',bar).filter(s=>s.value).length;count.textContent=n?`(${n})`:'';};
 btn.addEventListener('click',()=>{const open=!bar.classList.contains('is-open');bar.classList.toggle('is-open',open);btn.setAttribute('aria-expanded',String(open));});
 bar.addEventListener('change',update);
 root?.querySelector('[data-clear-filters]')?.addEventListener('click',()=>setTimeout(update));
 update();
});
})();
